module.exports = __webpack_public_path__ + "panels.invited.01-1434d421112a0c76f6398edf960c8d68.png";